export default __webpack_public_path__ + "static/media/ic_add_a_photo_24px.2fb9135a.svg";